// extracted by mini-css-extract-plugin
export default {"page_wrap":"Candidate_page_wrap__MXpyL","title":"Candidate_title__QIqjH","date_selection":"Candidate_date_selection__V9Oa2"};